import { useContext } from 'react'
import { MousePointer2 } from "lucide-react"
import { ReplayMouseContext } from '../context/ReplayMouseContext'

export default function ReplayMouseLayer() {
  const { mousePos, isClicking } = useContext(ReplayMouseContext)

  if (!mousePos || mousePos.x == null) return null

  // Use percentage-based positioning relative to the parent container
  // The parent should be the replay workspace content area with position: relative
  return (
    <div 
      style={{
        position: 'absolute',  // Changed from 'fixed'
        left: `${mousePos.x * 100}%`,
        top: `${mousePos.y * 100}%`,
        pointerEvents: 'none', 
        zIndex: 9999,
      }}
    >
      <div style={{ position: 'relative' }}>
        <MousePointer2 
          fill={isClicking ? "#ef4444" : "black"}
          color="white" 
          size={24} 
          style={{ 
            filter: 'drop-shadow(0px 2px 2px rgba(0,0,0,0.3))',
            transform: isClicking ? 'scale(0.9)' : 'scale(1)',
            transition: 'transform 0.1s ease'
          }}
        />
        {isClicking && (
          <div style={{
            position: 'absolute',
            top: -10, left: -10,
            width: 40, height: 40,
            borderRadius: '50%',
            border: '2px solid #ef4444',
            animation: 'ping 0.5s cubic-bezier(0, 0, 0.2, 1)'
          }} />
        )}
      </div>
    </div>
  )
}